import {WeaCheckbox,WeaInput,WeaDatePicker,WeaSelect} from 'ecCom';
import {Button,Row,Col} from 'antd';
import {i18n} from '../public/i18n';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

class Main extends React.Component {
  constructor(props) {
    super(props);
  }
  onBtnClick() {
    this.props.onBtnClick &&　this.props.onBtnClick(this.props.value);
  }
  render() {
    const {props} = this;
    return (
      <div className="hrm-input-btn">
        <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@nvoldm`}>
          <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@5vderb`} span={2}><WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@e5g18z`} {...props}/></Col>
          <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@54t17w`} span={8}>{i18n.label.enableDate()}：<WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@5sctub`} {...props}/>{getLabel('386546',"天后")}</Col>
          <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@16gk2h`} span={4}><WeaDatePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaDatePicker@m4wp7k`} {...props}/></Col>
          <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@3goh5p`} span={8}>{i18n.label.enableMode()}：<WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@rdvkxv`} {...props}/></Col>
        </Row>
      </div>
    )
  }
}
export default Main;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/coms/needAutoBtn.js